import { z } from 'zod';

export const baseLocationSchema = z.object({
  label: z.string().trim().min(3, 'Wpisz adres bazy.').max(255, 'Adres może mieć najwyżej 255 znaków.'),
  lat: z.number({ error: 'Wskaż bazę na mapie.' }).min(49, 'Baza musi leżeć w Polsce.').max(54.9, 'Baza musi leżeć w Polsce.'),
  lng: z.number({ error: 'Wskaż bazę na mapie.' }).min(14, 'Baza musi leżeć w Polsce.').max(24.2, 'Baza musi leżeć w Polsce.'),
});
export type BaseLocationRequest = z.input<typeof baseLocationSchema>;

export const geoSuggestQuerySchema = z.object({ q: z.string().max(200).default('') });
export const geoGeocodeQuerySchema = z.object({
  address: z.string().trim().min(3, 'Wpisz adres.').max(255),
});
